import { jsxs, jsx } from "react/jsx-runtime";
const VisualisationIndicatorIcon = (props) => /* @__PURE__ */ jsxs("svg", { ...props, viewBox: "0 0 1024 1024", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M161.053 518.724C161.053 551.208 178.165 569.771 208.619 569.771C238.783 569.771 255.896 551.498 255.896 518.724V225.784C255.896 190.399 233.272 167.486 199.338 167.486C179.905 167.486 159.312 174.157 136.689 188.659L89.4131 220.273C72.3008 231.005 63.5996 243.767 63.5996 257.979C63.5996 277.121 77.5215 291.043 96.6641 291.043C106.235 291.043 114.356 288.143 129.438 278.571L159.893 257.979H161.053V518.724Z",
      fill: "black",
      fillOpacity: "0.65"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M328.115 525.685C328.115 550.048 346.678 566 374.812 566H573.198C600.462 566 616.994 551.788 616.994 528.295C616.994 504.512 600.172 490.01 573.198 490.01H452.542V485.949L535.203 402.418C583.64 354.852 603.362 318.887 603.362 277.991C603.362 211.572 545.064 162.846 465.304 162.846C386.123 162.846 325.215 213.312 325.215 267.26C325.215 289.303 341.167 304.965 364.08 304.965C380.902 304.965 391.924 297.424 404.686 277.701C417.447 251.888 435.43 239.416 460.083 239.416C490.537 239.416 511.13 258.559 511.13 286.982C511.13 309.025 498.078 329.908 467.044 361.522L366.69 464.776C337.687 493.2 328.115 508.282 328.115 525.685Z",
      fill: "black",
      fillOpacity: "0.65"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M659.63 481.309C659.63 530.905 722.858 574.701 803.489 574.701C894.852 574.701 959.53 525.104 959.53 455.205C959.53 404.738 923.855 364.423 876.289 360.942V354.562C916.314 349.631 947.929 311.636 947.929 269C947.929 206.642 888.761 162.846 804.069 162.846C725.759 162.846 663.98 204.901 663.98 252.758C663.98 274.221 679.933 289.303 702.266 289.303C717.348 289.303 729.529 283.212 739.971 269.58C757.663 246.087 777.386 235.065 802.329 235.065C834.813 235.065 857.437 253.628 857.437 280.602C857.437 307.575 834.233 327.298 802.909 327.298H780.286C759.983 327.298 745.481 342.96 745.481 363.263C745.481 384.436 760.273 399.808 780.286 399.808H803.779C841.484 399.808 866.718 420.69 866.718 451.435C866.718 482.469 841.774 502.481 803.489 502.481C775.355 502.481 752.442 490.3 734.75 466.517C721.698 450.274 710.097 443.604 696.175 443.604C675.002 443.604 659.63 459.266 659.63 481.309Z",
      fill: "black",
      fillOpacity: "0.65"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M434 818C434 774.922 468.922 740 512 740C555.078 740 590 774.922 590 818C590 861.078 555.078 896 512 896C468.922 896 434 861.078 434 818Z",
      fill: "#337AB7"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M128 818C128 774.922 162.922 740 206 740C249.078 740 284 774.922 284 818C284 861.078 249.078 896 206 896C162.922 896 128 861.078 128 818Z",
      fill: "#5CBAEB"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M740 818C740 774.922 774.922 740 818 740C861.078 740 896 774.922 896 818C896 861.078 861.078 896 818 896C774.922 896 740 861.078 740 818Z",
      fill: "#0A3A83"
    }
  )
] });
export {
  VisualisationIndicatorIcon
};
